<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Audit Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Audit Trail" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read test task'">
      <template #gated-content>
        <b-row class="mb-3">
          <b-col>
            <b-table-simple borderless striped>
              <b-tbody>
                <b-tr />

                <b-tr>
                  <b-th class="text-nowrap">
                    Name
                  </b-th>
                  <b-td class="w-100">
                    {{ test_task.name }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Description
                  </b-th>
                  <b-td class="w-100">
                    {{ test_task.description }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Result Type
                  </b-th>
                  <b-td class="w-100">
                    {{ _.startCase(_.toLower(test_task.result_type)) }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Inspecific Scheduling
                  </b-th>
                  <b-td class="w-100">
                    {{ test_task.inspecific_scheduling ? 'True' : 'False' }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Required
                  </b-th>
                  <b-td class="w-100">
                    {{ test_task.required ? 'True' : 'False' }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Group
                  </b-th>
                  <b-td class="w-100">
                    {{ test_task.group ? 'True' : 'False' }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>
        </b-row>

        <div>
          <h3>
            Change Log
            <b-button class="float-right" variant="success" :to="`/${route_root}/${sample_type_id}/${test_process_id}/${test_task_id}/audit-trail-history`">
              View History
            </b-button>
          </h3>
        </div>
        <AuditChangeLogTable
          :model="test_task"
        />

        <h3>Relations</h3>
        <AuditRelationTable
          :model="test_task"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import AuditChangeLogTable from '@/components/shared/audit/AuditChangeLogTable'
import AuditRelationTable from '@/components/shared/audit/AuditRelationTable'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import TestTaskModel from '@/models/lab/TestTaskModel'
import { TestWorkflowRoutes } from '@/router/lab/TestWorkflowRoutes'

export default {
  name: "WorkflowTestTaskAuditTrail",
  components: {
    PermissionAlertGate,
    AuditChangeLogTable,
    AuditRelationTable,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      test_task: null,
      test_task_id: this.$route.params.test_task_id || null,
      sample_type_id: this.$route.params.sample_type_id || null,
      test_process_id: this.$route.params.test_process_id || null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/${this.route_root}/${this.sample_type_id}/${this.test_process_id}/${this.test_task_id}`,
            title: "View Test Task",
            variant: "info",
          }
        ]
      }
    },
    route_root () {
      return TestWorkflowRoutes.fetchRoot()
    }
  },
  async created () {
    this.loading = true

    this.test_task = new TestTaskModel({ id: this.test_task_id })

    const params = {}
    params.connection = ['auditCreatedBy', 'auditUpdatedBy']

    this.test_task.fetch({ params }).then(() => {
      this.loading = false
    })
  },
}
</script>
